




import { Vue, Component } from 'nuxt-property-decorator';
import notesStore from '@/store/notes.store';
import NotesList from './NotesList.vue';
import CreateEditNote from './CreateEditNote.vue';
import { NotesMode } from './NotesMode';

@Component({
  components: { NotesList, CreateEditNote }
})
export default class Notes extends Vue {
  get mode(): NotesMode {
    return notesStore.mode;
  }

  get currentComponent() {
    switch (this.mode) {
      case NotesMode.VIEW:
        return NotesList;
      case NotesMode.CREATE:
      case NotesMode.EDIT:
        return CreateEditNote;
    }
    throw new Error('No component with name:' + this.mode);
  }
}
